import superAgentDefaults from 'superagent-defaults';
import superAgentVerboseErrors from 'superagent-verbose-errors';

const request = superAgentDefaults();
request.use(superAgentVerboseErrors);

request.set('Accept', 'application/json').set('Content-type', 'application/json').timeout({
  response: 30000, // Wait 30 seconds for the server to start sending,
  deadline: 45000, // but allow 45 seconds for the server to respond
});

export default request;
